import React from 'react';
import YouTube from 'react-youtube';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

// core components
import Navbar from "./layouts/Navbar.js";
import Footer from "./layouts/Footer.js";

import Slider from 'react-slick';
import '../assets/css/Service.css'
import '../assets/css/components/Slider.css';

// Image import
import tns01Kor from '../assets/img/TNS_01_kor.png';
import tns01Eng from '../assets/img/TNS_01_eng.png';
import technologyImg3 from '../assets/img/technology_img3.jpg';
import tns02Kor from '../assets/img/TNS_02_kor.png';
import tns02Eng from '../assets/img/TNS_02_eng.png';
import technologyImg3_2Kor from '../assets/img/technology_img3_2_kor.png';
import technologyImg3_2Eng from '../assets/img/technology_img3_2_eng.png';
import technologyImg3_3 from '../assets/img/technology_img3_3.png';
import technologyImg3_4 from '../assets/img/technology_img3_4.png';
import technologyImg3_5 from '../assets/img/technology_img3_5.png';
import technologyImg3_6 from '../assets/img/technology_img3_6.png';
import technologyImg4Kor from '../assets/img/technology_img4_kor.png';
import technologyImg4Eng from '../assets/img/technology_img4_eng.png';

import installation_img1 from '../assets/img/installation_img1.jpg';
import installation_img2 from '../assets/img/installation_img2.jpg';
import installation_img3 from '../assets/img/installation_img3.jpg';
import installation_img4 from '../assets/img/installation_img4.jpg';
import installation_img5 from '../assets/img/installation_img5.jpg';
import installation_img6 from '../assets/img/installation_img6.jpg';

export default function SubWAVE() {
  const { t, i18n } = useTranslation();
  const overviewTopImage = i18n.language?.startsWith('ko') ? tns01Kor : tns01Eng;
  const technologyOverviewImage = i18n.language?.startsWith('ko') ? tns02Kor : tns02Eng;
  const technologyDetailImage = i18n.language?.startsWith('ko') ? technologyImg4Kor : technologyImg4Eng;
  const technologySubImage = i18n.language?.startsWith('ko') ? technologyImg3_2Kor : technologyImg3_2Eng;

  useEffect(() => {
    const lang = localStorage.getItem('lang') || 'ko';
    if (i18n.language !== lang) {
      i18n.changeLanguage(lang);
    }
  }, [i18n]);
  const settings2 = {
    centerMode: true,
    slidesToShow: 5,
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 3500,
    responsive: [
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          centerMode: true,
          dots: false
        }
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          dots: true
        }
      },
    ]
  };
  
  return (
    <>
    <Navbar />
    <div className="wrapper">

      <div id="SubWaveHeader" className="Hero">
        <div className="HeaderSection fadeDivide">
          <div className="HeaderSectionTxtBox">
            <div className="HeaderSectionSubTitle fadeDivide">{t('TNS')}</div>
            <div className="HeaderSectionTitle fadeDivide">TNS</div>
            <div className="HeaderSectionTxt fadeDivide">{t('SubWAVE.Header.Title')}</div>
          </div>
        </div>
      </div>

      <div id="Overview_SubWAVE">
        <div className="Section">
          <div className="SectionHeaderFull">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark fadeDivide">{t('SubWAVE.Overview.Category')}</div>
              <div className="SectionHeaderTitle fadeDivide">
                <span className="SectionHeaderTitleDesc fadeDivide">{t('SubWAVE.Header.Subtitle1')}</span>
                <span className="SectionHeaderTitleMain fadeDivide">{t('SubWAVE.Header.Subheading')}</span>
              </div>
              <div className="SectionHeaderDescription fadeDivide" style={{lineHeight:'34px', maxWidth:'1100px'}}>
                <span>{t('SubWAVE.Header.Description1')}</span><br/>
                <span>{t('SubWAVE.Header.Description2')} </span>
                <span style={{fontWeight:700}}>{t('SubWAVE.Header.Description2Highlight')}</span><br/>
                <span style={{fontSize:'16px', lineHeight:'24px'}}>{t('SubWAVE.Header.Description3')}</span>
              </div>
            </div>
          </div>
          <div className="SectionContents">
            <div className="OverviewContent" style={{gap:'56px'}}>
              <div className="OverviewImgBox fadeDivide">
                <img style={{width:'90%'}} src={overviewTopImage} alt="SubWAVE Overview"/>
              </div>

              <div className="OverviewText">
                <div className="ProductDescription subwaveLongDescription subwaveSideDescription fadeDivide">
                  <p>
                    {t('SubWAVE.Product.DescriptionTop1')}<br/>
                    {t('SubWAVE.Product.DescriptionTop2')}<br/>
                    {t('SubWAVE.Product.DescriptionTop3')}
                  </p>

                  <p>
                    <span className="subwaveEmphasis">{t('SubWAVE.Product.DescriptionMidHighlight1')}</span>
                    {t('SubWAVE.Product.DescriptionMidTail1')}<br/>
                    <span className="subwaveEmphasis">{t('SubWAVE.Product.DescriptionMidHighlight2')}</span>
                    {t('SubWAVE.Product.DescriptionMidTail2')}<br/>
                    <span className="subwaveFootnote">{t('SubWAVE.Product.DescriptionMidFootnote')}</span>
                  </p>

                  <p>
                    {t('SubWAVE.Product.DescriptionBottom1')}<br/>
                    <span className="subwaveEmphasis">{t('SubWAVE.Product.DescriptionBottomHighlight1')}<br/>{t('SubWAVE.Product.DescriptionBottomHighlight2')} {t('SubWAVE.Product.DescriptionBottom2')}</span><br/>
                    {t('SubWAVE.Product.DescriptionBottom3')}
                  </p>
                </div>
              </div>
            </div>

            <div className="Grid4TextBoxes" style={{marginTop:'36px'}}>
                <div className="Grid4TextBox fadeDivide">
                <span className="Grid4TextBox_smallText">{t('SubWAVE.Grid.Item1.SmallText')}</span>{t('SubWAVE.Grid.Item1.Title')}<br/>
                </div>
                <div className="Grid4TextBox fadeDivide">
                  {t('SubWAVE.Grid.Item2.Title1')}<br/>{t('SubWAVE.Grid.Item2.Title2')}
                </div>
                <div className="Grid4TextBox fadeDivide">
                  {t('SubWAVE.Grid.Item3.Title')}
                </div>
                <div className="Grid4TextBox fadeDivide" style={{gap:0}}>
                  {t('SubWAVE.Grid.Item4.Title1')}<br/>{t('SubWAVE.Grid.Item4.Title2')}
                </div>
            </div>
          </div>
        </div>
      </div>

      <div id="Installation">
        <div className="Section">
          <div className="SectionHeaderFull fadeDivide">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryBright">{t('SubWAVE.Installation.Category')}</div>
              <div className="SectionHeaderTitle whiteFonts" style={{lineHeight:'50px', fontWeight:'500'}}>
                <span>{t('SubWAVE.Installation.Title')}</span></div>
              </div>
              <div className="SectionHeaderDescription">
              </div>
          </div>
          <div className="SectionContents">
            <div className="multipleImgBox">
              <div className="ImgWithTitle fadeDivide">
                <img className="InstallationImg" src={installation_img1} alt="SubWAVE Installation Example"/>
                <p>{t('SubWAVE.Installation.Image1Title')}</p>
              </div>
              <div className="ImgWithTitle fadeDivide">
                <img className="InstallationImg" src={installation_img2} alt="SubWAVE Installation Example"/>
                <p>{t('SubWAVE.Installation.Image2Title')}</p>
              </div>
              <div className="ImgWithTitle fadeDivide">
                <img className="InstallationImg" src={installation_img3} alt="SubWAVE Installation Example"/>
                <p>{t('SubWAVE.Installation.Image3Title')}</p>
              </div>
              <div className="ImgWithTitle fadeDivide">
                <img className="InstallationImg" src={installation_img4} alt="SubWAVE Installation Example"/>
                <p>{t('SubWAVE.Installation.Image4Title')}</p>
              </div>
              <div className="ImgWithTitle fadeDivide">
                <img className="InstallationImg" src={installation_img5} alt="SubWAVE Installation Example"/>
                <p>{t('SubWAVE.Installation.Image5Title')}</p>
              </div>
              <div className="ImgWithTitle fadeDivide">
                <img className="InstallationImg" src={installation_img6} alt="SubWAVE Installation Example"/>
                <p>{t('SubWAVE.Installation.Image6Title')}</p>
              </div>
            </div>
            <div className="OverviewContent">
              <img id="TechnologyImg3_1" style={{width:'80%'}} src={technologyOverviewImage} alt="SubWAVE Technology"/>
            </div>
          </div>
        </div>
      </div>

      <div id="Technology_SubWAVE">
        <div className="Section">
          <div className="SectionHeaderFull fadeDivide">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryDark">{t('SubWAVE.Technology.Category')}</div>
              <div className="SectionHeaderTitle" style={{lineHeight:'50px'}}>
                <span className="SectionHeaderTitleDesc">{t('SubWAVE.Technology.TitleDesc')}<br/></span>
                <span>{t('SubWAVE.Technology.TitleMain')}</span>
              </div>
              <div className="SectionHeaderDescription">
              </div>
            </div>
          </div>
          <div className="SectionContents fadeDivide">
            <div className="OverviewContent">
              <img id="TechnologyImg4" src={technologyDetailImage} alt="SubWAVE Technology"/>
              <img className="InstallationImg" src={technologySubImage} alt="SubWAVE Installation Example"/>
            </div>
          </div>
        </div>
      </div>

      <div id="Features_SubWAVE">
        <div className="Section">
          <div className="SectionHeaderFull fadeDivide">
            <div className="SectionHeaderTxtbox">
              <div className="SectionHeaderCategory CategoryBright"></div>
              <div className="SectionHeaderTitle whiteFonts" style={{lineHeight:'50px', fontWeight:'500'}}>
                <span>{t('SubWAVE.Features.Title')}</span></div>
              </div>
              <div className="SectionHeaderDescription whiteFonts"></div>
          </div>
          <div className="ContentSlider fadeDivide">
            <div className="SliderBg_subwave"></div>
            <Slider {...settings2} className='subSlider'>
              <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologyImg3_3} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">{t('SubWAVE.Slider.Patent.Title')}</div>
                      <div className="subSliderTxt">{t('SubWAVE.Slider.Patent.Desc')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologyImg3_4} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">{t('SubWAVE.Slider.Certification.Title')}</div>
                      <div className="subSliderTxt">{t('SubWAVE.Slider.Certification.Desc')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologySubImage} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">{t('SubWAVE.Slider.Performance.Title')}</div>
                      <div className="subSliderTxt">{t('SubWAVE.Slider.Performance.Desc')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologyImg3_3} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">{t('SubWAVE.Slider.Patent.Title')}</div>
                      <div className="subSliderTxt">{t('SubWAVE.Slider.Patent.Desc')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologyImg3_4} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">{t('SubWAVE.Slider.Certification.Title')}</div>
                      <div className="subSliderTxt">{t('SubWAVE.Slider.Certification.Desc')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologyImg3_5} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">{t('SubWAVE.Slider.Performance.Title')}</div>
                      <div className="subSliderTxt">{t('SubWAVE.Slider.Performance.Desc')}</div>
                    </div>
              </div>
              <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologyImg3_6} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">{t('SubWAVE.Slider.Patent2.Title')}</div>
                      <div className="subSliderTxt">{t('SubWAVE.Slider.Patent2.Desc')}</div>
                    </div>
              </div>

              {/* <div className="slider-content">
                <img className="subSliderImg_subwave" src={technologyImg3_2} alt="History"/>
                    <div className="subSliderContents">
                      <div className="subSliderTitle">2023.09</div>
                      <div className="subSliderTxt">Lone-Smart 서비스 오픈</div>
                    </div>
              </div> */}
            </Slider>
          </div>
          {/* <div className="SectionContents" id="Features_SubWAVE_Section">
            
            <div className="OverviewContent">
              <img id="TechnologyImg3_1" src={technologyImg3_3} alt="SubWAVE Technology"/>
            </div> */}
            
            {/* <img id="TechnologyImg3_3" src={technologyImg3_3} className="fadeDivide" alt="SubWAVE Technology"/>
            <img id="TechnologyImg3_4" src={technologyImg3_4} className="fadeDivide" alt="SubWAVE Technology"/>
            <img id="TechnologyImg3_5" src={technologyImg3_5} className="fadeDivide" alt="SubWAVE Technology"/> */}
            {/* <YouTube
              videoId="UFPgJDRMCKg"
              id="TechnologyVideo"
              className="IntroVideo fadeDivide"
              opts={{
                playerVars: {
                  autoplay: 0, //자동재생 O
                  rel: 0, //관련 동영상 표시하지 않음
                  modestbranding: 1, // 컨트롤 바에 youtube 로고를 표시하지 않음
                },
              }}
              onEnd={(e)=>{e.target.stopVideo(0);}}
            /> */}
            
          {/* </div> */}
        </div>
      </div>

    </div>
    <Footer />
    </>
  )
};